import { createAction } from "../fns/createAction";
import { fns, libTypes } from "@holta/lib";
import toast, { Toaster } from 'react-hot-toast';

export const setActiveOrders = createAction("SET_ACTIVE_ORDERS", (newState, orders: libTypes.Order[]) => {
    newState.orders = fns.orders.filterActiveOrders(orders);
});

